import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import type { EmbedType } from '../DonationFormEmbedModal';

import * as styles from './EmbedTypeSelector.css';

interface IProps {
  selectedType: EmbedType;
  onSelectInline: () => void;
  onSelectPopup: () => void;
}

function EmbedTypeSelector({
  selectedType,
  onSelectInline,
  onSelectPopup,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.embedOptions}>
      <button
        className={`${styles.embedOption} ${selectedType === 'inline' ? styles.selected : ''}`}
        onClick={onSelectInline}
        type={'button'}
      >
        <Text.DefaultSemibold className={styles.embedOptionTitle}>
          {t('Inline Embed')}
        </Text.DefaultSemibold>
        <Text.SmallRegular className={styles.embedOptionDescription}>
          {t('Display the form directly on your page')}
        </Text.SmallRegular>
      </button>

      <button
        className={`${styles.embedOption} ${selectedType === 'popup' ? styles.selected : ''}`}
        onClick={onSelectPopup}
        type={'button'}
      >
        <Text.DefaultSemibold className={styles.embedOptionTitle}>
          {t('Pop-up Button')}
        </Text.DefaultSemibold>
        <Text.SmallRegular className={styles.embedOptionDescription}>
          {t('Open the form in a modal when clicked')}
        </Text.SmallRegular>
      </button>
    </div>
  );
}

export default EmbedTypeSelector;
